/**
 * Constantes pour les routes des modules
 * Basé sur le document d'analyse et conception SyncMP
 */
export const MODULE_ROUTES: Record<string, string> = {
  users: '/users',
  configuration: '/config',
  ressources: '/inventory',
  transactions: '/gestion-transactions',
  couts: '/gestion-couts',
  'calcul-financier': '/calcul-financier',
} as const

export const TASKBAR_ROUTES: Record<string, string> = {
  home: '/',
  // Client routes
  'my-requests': '/client/my-requests',
  'my-visits': '/client/my-visits',
  'messages-client': '/client/messages',
  'dashboard-client': '/client',
  // Professional routes
  'dashboard-professional': '/professional',
  'my-properties': '/dashboard',
  'calendar-visits': '/professional/visits',
  'my-leads': '/professional/leads',
  'messages-pro': '/professional/messages',
  // Admin routes
  'dashboard-admin': '/admin',
  'contact-requests': '/admin/contact-requests',
  'calendar-visits-admin': '/admin/visits',
  'messages-admin': '/admin/messages',
} as const

